module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_95-8ed2afba209fec77d587fe6982bac3da.png";